<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPageLoader" :color="loaderColor"></loading>
    <div class="flex justify-between my-7">
      <div class="w-3/12 pr-10">
        <div class="text-dark text-lg font-bold mb-3">{{ $t('frontend_grooveblog_current_theme') }}</div>
        <div class="text-base text-grey-600">
          {{ $t('frontend_grooveblog_current_theme_desc') }}
        </div>
      </div>
      <div class="flex-1 bg-white flex rounded border border-grey-1">
        <div style="width: 298px; height: 300px">
          <img class="w-full h-full object-cover rounded-l" :src="selectedTheme.theme.image &&
            require('../../assets/images/theme/' + selectedTheme.theme.image)
            " />
        </div>
        <div class="flex flex-col justify-between flex-1 p-10">
          <div>
            <div class="text-2xl mb-3" style="margin-top: -5px">
              {{ selectedTheme.theme.name }}
            </div>
            <div style="color: #9895b1">
              {{ selectedTheme.theme.description }}
            </div>
          </div>
          <div>
            <gd-button size="auto" class="px-5 h-10" style="font-size: 15px; letter-spacing: 0.3px" @click="themeSetting"
              variant="primary">{{ $t('frontend_grooveblog_customize_theme') }}</gd-button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between mb-12"
      v-if="selectedTheme.theme.name && selectedTheme.theme.name !== 'GrooveBlog Classic'">
      <div class="w-3/12 pr-10">
        <div class="text-dark text-lg font-bold mb-3">{{ $t('frontend_grooveblog_free_themes') }}</div>
        <div class="text-base text-grey-600 mb-4">
          {{ $t('frontend_grooveblog_free_themes_desc') }}
        </div>
        <gd-button size="auto" class="px-7 h-10 border-grey-1">{{ $t('frontend_grooveblog_see_all_free_themes')
        }}</gd-button>
      </div>
      <div class="flex-1 flex flex-wrap theme-list" style="margin: 0 -0.5rem">
        <div class="w-4/12 p-2 pt-0" v-for="theme in themeList" :key="theme.id">
          <div class="flex flex-col bg-white rounded border border-grey-1">
            <img class="object-cover" style="height: 185px" :src="theme.image &&
              require('../../assets/images/theme/' + theme.image)
              " />
            <div class="p-4">
              <h5>{{ theme.name }}</h5>
              <div class="flex mt-5">
                <gd-button size="auto" class="px-5 h-10" variant="primary"
                  @click="useTheme(theme.id, theme.route_name)">{{ $t('frontend_grooveblog_use_this_theme') }}</gd-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';
import defaultThemeSetting from './themeList/defaultTheme/theme_setting.json';
import secondThemeSetting from './themeList/secondTheme/theme_setting.json';
import thirdThemeSetting from './themeList/thirdTheme/theme_setting.json';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Themes' };
  },
  components: { Loading },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      defaultThemeStyle: defaultThemeSetting.themeStyle,
      secondThemeStyle: secondThemeSetting.themeStyle,
      thirdThemeStyle: thirdThemeSetting.themeStyle,
      defaultThemeLayout: defaultThemeSetting.themeLayout,
      secondThemeLayout: secondThemeSetting.themeLayout,
      thirdThemeLayout: thirdThemeSetting.themeLayout,
      homeRadioValue: 2,
      postRadioValue: 2,
      categoryRadioValue: 2,
      blogId: '',
      themeList: [],
      customizeShow: false,
      selectedTheme: {
        theme: {},
      },
      currentTheme: {
        blog_id: '',
        theme_id: '',
        theme_setting: {},
        layout_setting: {
          homePage: {},
          postPage: {},
          categoryPage: {},
        },
      },
    };
  },
  mounted() {
    this.blogId = localStorage.getItem('blog-id');
    this.getThemes();
    this.getCurrentTheme(this.blogId);
  },
  methods: {
    getThemes() {
      this.showLoader();
      axios
        .get('/themes')
        .then((response) => {
          this.themeList = response.data.data;
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async useTheme(themeId, routeName) {
      this.customizeShow = true;
      this.currentTheme.blog_id = this.blogId;
      this.currentTheme.theme_id = themeId;
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_grooveblog_swal_apply_style_theme'),
        text: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('frontend_cancel'),
        confirmButtonText: this.$t('frontend_grooveblog_swal_apply_style_theme_confirm'),
      });
      if (accept) {
        if (routeName === 'theme_default') {
          this.currentTheme.theme_setting = this.defaultThemeStyle;
          const themeLayoutHome = this.defaultThemeLayout.homePage;
          const themeLayoutPost = this.defaultThemeLayout.postPage;
          const themeLayoutCategory = this.defaultThemeLayout.categoryPage;
          this.getLayoutSetting(
            themeLayoutHome,
            themeLayoutPost,
            themeLayoutCategory
          );
        } else if (routeName === 'theme_second') {
          this.currentTheme.theme_setting = this.secondThemeStyle;
          const themeLayoutHome = this.secondThemeLayout.homePage;
          const themeLayoutPost = this.secondThemeLayout.postPage;
          const themeLayoutCategory = this.secondThemeLayout.categoryPage;
          this.getLayoutSetting(themeLayoutHome, themeLayoutPost, themeLayoutCategory);
        } else if (routeName === 'theme_third') {
          this.currentTheme.theme_setting = this.thirdThemeStyle;
          const themeLayoutHome = this.thirdThemeLayout.homePage;
          const themeLayoutPost = this.thirdThemeLayout.postPage;
          const themeLayoutCategory = this.thirdThemeLayout.categoryPage;
          this.getLayoutSetting(themeLayoutHome,themeLayoutPost,themeLayoutCategory);
        }
        this.showLoader();
        await axios
          .post('/select-themes', this.currentTheme)
          .then(() => { })
          .catch((error) => {
            console.log(error);
          });
        this.getCurrentTheme(this.blogId);
      }
    },
    async getCurrentTheme(blogId) {
      await axios
        .get(`/themes/${blogId}`)
        .then((response) => {
          this.selectedTheme = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      // this.checkTheme();
      this.hideLoader();
    },
    themeSetting() {
      this.$router.push({ name: `${this.selectedTheme.theme.route_name}` });
    },
    getLayoutSetting(home, post, category) {
      for (let setting in home) {
        if (home[setting].type === 'radio') {
          this.$set(
            this.currentTheme.layout_setting.homePage,
            setting,
            this.homeRadioValue
          );
        } else {
          this.$set(
            this.currentTheme.layout_setting.homePage,
            setting,
            home[setting].value
          );
        }
      }
      for (let setting in post) {
        if (post[setting].type === 'radio') {
          this.$set(
            this.currentTheme.layout_setting.postPage,
            setting,
            this.postRadioValue
          );
        } else {
          this.$set(
            this.currentTheme.layout_setting.postPage,
            setting,
            post[setting].value
          );
        }
      }
      for (let setting in category) {
        if (category[setting].type === 'radio') {
          this.$set(
            this.currentTheme.layout_setting.categoryPage,
            setting,
            this.categoryRadioValue
          );
        } else {
          this.$set(
            this.currentTheme.layout_setting.categoryPage,
            setting,
            category[setting].value
          );
        }
      }
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.theme-list>.p-2:not(:first-child) {
  display: none;
}
</style>
